import { emailLocalPart } from "./schoolEmailNameGuess";

export interface NamedStudent {
  email: string;
  givenName?: string | null;
  familyName?: string | null;
}

export function hasSavedName(student: NamedStudent): boolean {
  return Boolean(student.givenName?.trim() && student.familyName?.trim());
}

/** `Family, Given` once both names are saved. Otherwise the email local part. */
export function studentListLabel(student: NamedStudent): string {
  const given = student.givenName?.trim() ?? "";
  const family = student.familyName?.trim() ?? "";
  if (given && family) return `${family}, ${given}`;
  return emailLocalPart(student.email);
}

export function studentMatchesQuery(student: NamedStudent, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return (
    student.email.toLowerCase().includes(q) ||
    studentListLabel(student).toLowerCase().includes(q) ||
    (student.givenName ?? "").toLowerCase().includes(q) ||
    (student.familyName ?? "").toLowerCase().includes(q)
  );
}

/** Saved names first, by family then given. Everyone else stays in email-local order. */
export function compareStudentsBySavedName(a: NamedStudent, b: NamedStudent): number {
  const aNamed = hasSavedName(a);
  const bNamed = hasSavedName(b);
  if (aNamed !== bNamed) return aNamed ? -1 : 1;
  if (aNamed && bNamed) {
    const byFamily = (a.familyName ?? "").localeCompare(b.familyName ?? "", undefined, { sensitivity: "base" });
    if (byFamily !== 0) return byFamily;
    return (a.givenName ?? "").localeCompare(b.givenName ?? "", undefined, { sensitivity: "base" });
  }
  return emailLocalPart(a.email).localeCompare(emailLocalPart(b.email), undefined, { sensitivity: "base" });
}
